module.exports = __webpack_public_path__ + "img/freaks_tab_highlight.e5c041f0.png";